import React from "react";
import { Box } from "@mui/material";

interface IDotLegalSectionProps {
    children: React.ReactNode;
    noMargin?: boolean;
    noPadding?: boolean;
    noBorder?: boolean;
}

/** Shared so anything framed beside a section, such as a DotLegalCollapse, draws the same edge. */
export const sectionBorderColor = "rgba(0, 0, 0, 0.08)";

function DotLegalSection({ children, noMargin, noPadding, noBorder }: IDotLegalSectionProps) {
    const sectionBorderStyle = {
        mb: 2,
        border: noBorder ? undefined : `1px solid ${sectionBorderColor}`,
        borderRadius: "10px",
        padding: noPadding ? undefined : 2,
    };

    return <Box sx={{ ...sectionBorderStyle, ...(noMargin && { mb: 0 }) }}>{children}</Box>;
}

export default DotLegalSection;
